var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _polygon, _polygon2, _polygon3, _polygon4, _g4, _path7, _path8, _path9, _g5, _g6, _path10, _path11, _path12, _path13, _path14, _g7, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g8, _g9, _path22, _g10, _g11, _g12, _g13, _ellipse, _g14, _ellipse2, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _path23, _path24, _path25, _polygon5, _polygon6, _path26, _g37, _g38, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g39, _g40, _g41, _g42, _g43, _path27, _path28, _path29, _g44, _polygon7, _rect11, _path30, _path31, _path32, _g45, _path33, _path34, _path35, _path36, _path37, _g46, _path38, _g47, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 640",
    style: {
      enableBackground: "new 0 0 850 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFD247;}\n\t.st2{fill:#043C5E;}\n\t.st3{fill:#F8A913;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FCC030;}\n\t.st6{fill:#B0D9C8;}\n\t.st7{fill:#63C1C5;}\n\t.st8{fill:url(#SVGID_2_);}\n\t.st9{fill:url(#SVGID_3_);}\n\t.st10{fill:#E4EEFA;}\n\t.st11{fill:#AFBEDE;}\n\t.st12{fill:#212B53;}\n\t.st13{fill:#F8B68F;}\n\t.st14{fill:#F4A086;}\n\t.st15{fill:#00666A;}\n\t.st16{fill:#01898C;}\n\t.st17{fill:#F59C42;}\n\t.st18{fill:#E8375E;}\n\t.st19{fill:#FAB746;}\n\t.st20{fill:#EDF4FC;}\n\t.st21{fill:url(#SVGID_4_);}\n\t.st22{fill:#D1DBEA;}\n\t.st23{fill:#F7A605;}\n\t.st24{fill:#F18813;}\n\t.st25{opacity:0.33;fill:#FFFFFF;enable-background:new    ;}\n\t.st26{fill:#C2E4F2;}\n\t.st27{fill:url(#SVGID_5_);}\n\t.st28{fill:#5C6587;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.324,
    y1: 529.95,
    x2: 1380.1796,
    y2: 529.95,
    gradientTransform: "matrix(-1 0 0 -1 1709.024 640)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0F0EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0E4EF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.7,158H336c0,0-16.1-20.4,0-34.2c8.9-7.6,19.4-6.8,27.1-4.6c5,1.5,9.9-1.9,11-7 c1.8-8.4,7.4-19.4,23.4-25.9c15.8-6.4,25.7,3.4,31.5,13.4c1.9,3.3,7,2.8,8.1-0.8c5-15.8,22.4-36.8,79.6-36.8 c72.8,0,64.7,38.7,58.2,54.8c-1.1,2.8,1.3,5.7,4.2,5.1c11.2-2.4,32.1-5.5,41.4,1.8C633.7,134.2,633.7,158,633.7,158z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "742.2,588.7 664.1,345.9 668.6,345.9 746.7,588.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "701.9,588.7 623.8,345.9 628.2,345.9 706.3,588.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "688.8,408.9 688.8,412.6 647,412.5 646.3,408.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "680.2,385.4 680.2,389 638.3,389 637.6,385.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "673,361.9 673,365.5 631.2,365.5 630.5,361.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "696.5,432.8 696.5,436.4 654.6,436.4 653.9,432.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "703.6,456.6 703.6,460.2 661.8,460.2 661,456.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "711,481.4 712.7,485 670.9,485 670.1,481.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "718.8,506.1 720.5,509.7 678.7,509.7 678,506.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "726.2,530.3 727.9,533.9 686,533.9 685.3,530.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "732.3,555 734,558.7 692.1,558.6 691.4,555  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "547.6,588.7 625.7,345.9 621.2,345.9 543.1,588.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "588,588.7 666.1,345.9 661.6,345.9 583.5,588.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "601,408.9 601,412.6 642.8,412.5 643.6,408.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "609.7,385.4 609.7,389 651.5,389 652.2,385.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "616.8,361.9 616.8,365.5 658.6,365.5 659.4,361.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "593.4,432.8 593.4,436.4 635.2,436.4 635.9,432.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "586.2,456.6 586.2,460.2 628.1,460.2 628.8,456.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "578.8,481.4 577.1,485 619,485 619.7,481.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "571,506.1 569.3,509.7 611.1,509.7 611.8,506.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.6,530.3 561.9,533.9 603.8,533.9 604.5,530.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "557.5,555 555.9,558.7 597.7,558.6 598.4,555  "
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.5,224.8c0,0,45.9-127.5-28.1-193.8c-152.2,77.7-75.3,227.2-75.3,227.2L376.5,224.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.4,31c-0.5,0.3-1,0.5-1.6,0.8l-14.8,159l-68.7-72.1c-0.4,1-0.8,2.1-1.1,3.1l69.5,72.9l-4.3,45.9l3.1-1 l8.5-91.5l0,0l50.8-27.5c-0.1-1.1-0.2-2.1-0.3-3.2l-50.1,27.1l10.5-112.3C349.3,31.9,348.9,31.4,348.4,31L348.4,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.3,193.9c0,0-43.7-127.9-137.5-143.6c-71.7,89.2,15.7,184.2,15.7,184.2l107.3,49.6L342.3,193.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M293.5,107.4l-29.1,52.4L207,50.7c-0.7-0.1-1.5-0.3-2.2-0.4c-0.3,0.4-0.5,0.7-0.8,1.1l30.8,58.4l-54.1-13.1 c-0.1,0.5-0.3,1-0.4,1.5l-0.3,1.4l56.5,13.7l51.3,97.4l-95.7-19.9c0.5,1.1,1.1,2.3,1.6,3.4l95.9,20l36.4,69.1l1.8,0.8l0.5-2.9 L266,163l29.5-53.1C294.8,109.1,294.1,108.2,293.5,107.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M308,248.8c0,0-91.6-65.9-155.1-24.6c3.4,154.7,200.4,161.3,200.4,161.3L308,248.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.9,224.2c0,0.6,0,1.2,0.1,1.8l130.5,79.4l-78.1,28.5c0.9,0.7,1.8,1.5,2.7,2.2l78.7-28.7l51,31l-1.4-4.4 l-99.3-60.4l-15.3-61.4c-1.1-0.2-2.1-0.3-3.2-0.5l14.8,59.6l-79.1-48.1C153.9,223.6,153.4,223.9,152.9,224.2L152.9,224.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "480.9,117.5 515.8,98.3 533.6,94.7 547,96.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "480.9,117.5 546.2,100.7 547,96.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "548.1,112 548,112.1 545.2,122.2 481,117.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.5,106 551.2,98.4 481.3,117.4 541.5,115.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M707.5,235.4c-2.1-0.8-4.2-1.7-6.3-2.7c-0.5-0.2-1-0.1-1.3,0.4c-0.2,0.5-0.1,1,0.4,1.3 c2.1,1.1,4.3,2.1,6.5,2.8c0.8,0.3,1.6,0.5,2.4,0.8c0.3,0.1,0.6,0,0.8-0.1s0.3-0.3,0.3-0.5c0.2-0.5-0.1-1-0.6-1.2 C709,236,708.3,235.7,707.5,235.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M579.6,98.9c-3,0.4-6,0.9-9.4,1.5c-0.5,0.1-0.9,0.6-0.8,1.1c0.1,0.5,0.6,0.9,1.1,0.8 c3.3-0.6,6.4-1.1,9.3-1.5c0.2,0,0.3-0.1,0.4-0.2c0.3-0.2,0.4-0.5,0.4-0.9C580.6,99.2,580.1,98.9,579.6,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M595.5,99.7c0.2-0.2,0.4-0.4,0.4-0.8c0-0.5-0.4-1-0.9-1c-3,0-6.3,0.1-9.6,0.4c-0.5,0-0.9,0.5-0.9,1 s0.5,0.9,1,0.9c3.2-0.3,6.4-0.4,9.4-0.4C595.1,99.9,595.3,99.8,595.5,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M689.2,224c-0.4-0.4-1-0.4-1.3,0c-0.4,0.4-0.4,1,0,1.3c2.3,2.2,4.8,4.3,7.5,6.1c0.3,0.2,0.8,0.2,1.1,0 c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.4,0.2-1-0.3-1.3C693.8,228.1,691.4,226.2,689.2,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M685.3,221.2c0.4-0.3,0.5-0.9,0.1-1.3c-0.5-0.7-1.1-1.3-1.6-2c-1.3-1.8-2.6-3.7-3.6-5.7 c-0.3-0.5-0.8-0.6-1.3-0.4c-0.4,0.2-0.6,0.8-0.4,1.3c1.1,2,2.4,4,3.8,5.9c0.5,0.7,1.1,1.4,1.6,2.1 C684.2,221.5,684.8,221.6,685.3,221.2C685.2,221.2,685.3,221.2,685.3,221.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M677.3,208.4c0.1,0,0.1-0.1,0.2-0.1c0.3-0.3,0.5-0.7,0.3-1.1c-1.1-2.7-2.1-5.6-2.9-8.9 c-0.1-0.5-0.6-0.8-1.2-0.7c-0.5,0.1-0.8,0.6-0.7,1.2c0.8,3.3,1.8,6.3,3,9.1C676.2,208.3,676.8,208.6,677.3,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M652.1,127.4c0.8,1,1.6,1.9,2.3,2.9c1.1,1.5,2.2,3.1,3.2,4.7c0.3,0.4,0.9,0.6,1.3,0.3c0,0,0,0,0.1,0 c0.4-0.3,0.5-0.8,0.2-1.3c-1-1.6-2.1-3.2-3.3-4.8c-0.8-1-1.5-2-2.4-3c-0.3-0.4-0.9-0.5-1.3-0.1 C651.8,126.4,651.8,127,652.1,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M660.4,139.9c1.5,2.8,2.7,5.7,3.8,8.6c0.2,0.5,0.7,0.7,1.2,0.6c0.1,0,0.2-0.1,0.2-0.1 c0.3-0.2,0.5-0.7,0.3-1.1c-1.1-3-2.4-5.9-3.9-8.8c-0.2-0.5-0.8-0.6-1.3-0.4C660.3,138.8,660.1,139.4,660.4,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M641.5,116.8c2.4,2,4.7,4.1,6.9,6.4c0.3,0.4,0.9,0.4,1.3,0.1c0,0,0.1,0,0.1-0.1c0.4-0.4,0.4-1,0-1.3 c-2.2-2.3-4.6-4.5-7-6.5c-0.4-0.3-1-0.3-1.3,0.1C641,115.9,641.1,116.5,641.5,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M624,106c0.3,0.1,0.7,0.1,0.9-0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.2-0.5,0-1-0.5-1.3c-2.9-1.3-6-2.4-9-3.3 c-0.5-0.1-1,0.1-1.2,0.6c-0.1,0.5,0.1,1,0.6,1.2C618.2,103.6,621.1,104.7,624,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.8,178.8c0.2,0,0.3-0.1,0.5-0.2c0.3-0.2,0.4-0.5,0.4-0.9l-0.1-1.2c-0.3-2.8-0.6-5.5-1-8.2 c-0.1-0.5-0.5-0.9-1.1-0.8c-0.5,0.1-0.9,0.5-0.8,1.1c0.4,2.7,0.7,5.5,1,8.2l0.1,1.2C669.8,178.5,670.3,178.9,670.8,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M637,113.4c0.3,0.2,0.8,0.2,1.1,0c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.4,0.2-1-0.2-1.3c-2.6-1.8-5.4-3.5-8.2-5 c-0.5-0.2-1-0.1-1.3,0.4c-0.2,0.5-0.1,1,0.4,1.3C631.8,109.9,634.5,111.6,637,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M671.2,182.6c-0.5,0.1-0.9,0.5-0.8,1.1c0.5,3.7,0.9,6.7,1.4,9.4c0.1,0.5,0.6,0.9,1.1,0.8 c0.1,0,0.3-0.1,0.4-0.2c0.3-0.2,0.4-0.6,0.4-0.9c-0.5-2.7-1-5.7-1.4-9.3C672.2,182.9,671.7,182.5,671.2,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M715.3,237.5c-0.5-0.1-1,0.2-1.1,0.7s0.2,1,0.7,1.1c3,0.6,6.1,1,9.5,1.2c0.2,0,0.5-0.1,0.6-0.2 c0.2-0.2,0.4-0.4,0.4-0.7c0-0.5-0.4-1-0.9-1C721.2,238.5,718.1,238.1,715.3,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M666.5,152.6c-0.5,0.1-0.8,0.7-0.7,1.2c0.7,2.8,1.4,5.8,2,9.2c0.1,0.5,0.6,0.9,1.1,0.8 c0.2,0,0.3-0.1,0.4-0.2c0.3-0.2,0.4-0.6,0.4-0.9c-0.6-3.5-1.2-6.5-2-9.4C667.5,152.8,667,152.5,666.5,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M604,98.5c-1.1-0.1-2.2-0.2-3.3-0.3c-0.5,0-1,0.4-1,0.9s0.4,1,0.9,1c1.1,0.1,2.2,0.2,3.2,0.3 c2,0.2,4,0.6,6,1c0.3,0.1,0.6,0,0.8-0.2c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.5-0.2-1-0.7-1.1C608.1,99.1,606,98.8,604,98.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "90.9,157.7 84.5,170.4 98,167.3 144,152.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "84.5,170.4 107.4,168.9 101.8,166.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1082.7122,
    y1: 488.4,
    x2: 1139.8121,
    y2: 488.4,
    gradientTransform: "matrix(-1 0 0 -1 1226.7122 640)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 6.3e-7,
    style: {
      stopColor: "#F1F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0E4EF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "90.9,157.7 86.9,145.5 144,152.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1082.7122,
    y1: 471.1,
    x2: 1128.7769,
    y2: 471.1,
    gradientTransform: "matrix(-1 0 0 -1 1226.7122 640)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 6.3e-7,
    style: {
      stopColor: "#F1F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0E4EF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "144,152.8 98,167.3 104.8,185  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.6,183c-0.1-0.1-0.2-0.1-0.3-0.3c-0.4-0.4-0.3-1.1,0.1-1.5c1.4-1.2,2.9-2.3,4.5-3.3 c0.5-0.3,1.2-0.1,1.5,0.4s0.1,1.2-0.4,1.5c-1.5,0.9-2.9,1.9-4.2,3C90.4,183.2,89.9,183.2,89.6,183z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104.9,301.1C104.9,301,104.9,301,104.9,301.1c-3.2-1.9-6-4.3-8.5-7.4c-0.4-0.5-0.3-1.1,0.1-1.5 c0.5-0.4,1.1-0.3,1.5,0.1c2.3,2.8,5,5.1,7.9,6.8c0.5,0.3,0.7,1,0.4,1.5C106,301.1,105.4,301.3,104.9,301.1z M93,288.6 c-0.2-0.1-0.3-0.2-0.4-0.4c-1.8-3.2-3.2-6.7-4.1-10.3c-0.1-0.6,0.2-1.2,0.8-1.3c0.6-0.1,1.2,0.2,1.3,0.8 c0.8,3.4,2.2,6.7,3.9,9.8c0.3,0.5,0.1,1.2-0.4,1.5C93.7,288.8,93.3,288.8,93,288.6z M88,272.1c-0.3-0.2-0.6-0.5-0.6-0.9v-0.5 c-0.2-3.4,0-7,0.6-10.6c0.1-0.6,0.6-1,1.2-0.9c0.6,0.1,1,0.6,0.9,1.2c-0.5,3.4-0.7,6.8-0.5,10.1v0.5c0,0.6-0.4,1.1-1,1.2 C88.4,272.2,88.2,272.2,88,272.1z M89.8,254.9c-0.4-0.2-0.7-0.7-0.6-1.2c0.9-3.3,2.1-6.8,3.6-10.4c0.2-0.5,0.9-0.8,1.4-0.6 s0.8,0.9,0.6,1.4c-1.5,3.5-2.6,6.9-3.5,10.1c-0.2,0.6-0.7,0.9-1.3,0.8C90,255,89.9,254.9,89.8,254.9z M96.1,238.7 c-0.5-0.3-0.7-0.9-0.5-1.4c0.1-0.2,0.2-0.5,0.4-0.7c-1.6-0.8-3.2-1.6-4.7-2.6c-0.5-0.3-0.6-1-0.3-1.5s1-0.6,1.5-0.3 c1.4,0.9,2.9,1.8,4.5,2.5c1.2-2.2,2.4-4.5,3.9-7c0.3-0.5,1-0.7,1.5-0.4s0.7,1,0.4,1.5c-1.4,2.4-2.6,4.6-3.7,6.8 c1,0.4,2,0.7,3.1,1c0.6,0.2,0.9,0.8,0.7,1.3c-0.2,0.6-0.8,0.9-1.3,0.7c-1.2-0.3-2.3-0.7-3.5-1.2c-0.1,0.3-0.3,0.5-0.4,0.8 C97.3,238.7,96.6,239,96.1,238.7L96.1,238.7z M86.4,229.8c-0.1-0.1-0.2-0.1-0.3-0.2c-1.6-1.7-3.1-3.5-4.2-5.5 c-0.7-1.2-1.4-2.5-1.9-3.9c-0.2-0.5,0-1.2,0.6-1.4s1.2,0,1.4,0.6c0.5,1.2,1.1,2.4,1.8,3.6c1.1,1.8,2.4,3.5,3.9,5.1 c0.4,0.4,0.4,1.1,0,1.5C87.3,230,86.8,230,86.4,229.8z M107.6,239.6c-0.4-0.2-0.6-0.6-0.6-1.1c0.1-0.6,0.6-1,1.2-1 c3.6,0.3,7.1,0,10.4-0.8c0.6-0.1,1.2,0.2,1.3,0.8s-0.2,1.2-0.8,1.3c-3.6,0.9-7.3,1.2-11.1,0.9 C107.9,239.7,107.8,239.7,107.6,239.6z M78.6,214.5c-0.3-0.1-0.5-0.4-0.6-0.8c-0.6-3.6-0.7-7.4-0.1-11.2c0.1-0.6,0.6-1,1.2-0.9 c0.6,0.1,1,0.6,0.9,1.2c-0.5,3.6-0.5,7.1,0.1,10.5c0.1,0.6-0.3,1.1-0.9,1.2C79.1,214.7,78.8,214.6,78.6,214.5z M124.5,236.5 c-0.2-0.1-0.4-0.3-0.5-0.5c-0.3-0.5-0.1-1.2,0.5-1.4c0.8-0.4,1.6-0.9,2.3-1.4c2.1-1.4,4-3.2,5.5-5.3c0.3-0.5,1-0.6,1.5-0.2 c0.5,0.3,0.6,1,0.2,1.5c-1.6,2.3-3.7,4.3-6.1,5.8c-0.8,0.5-1.7,1-2.5,1.5C125.2,236.7,124.8,236.6,124.5,236.5z M104.6,223.5 L104.6,223.5c-0.6-0.4-0.7-1-0.4-1.5c2.4-3.8,4.6-6.5,7-8.6c0.4-0.4,1.1-0.4,1.5,0.1c0.4,0.4,0.4,1.1-0.1,1.5 c-2.2,2-4.3,4.6-6.6,8.2C105.7,223.6,105.1,223.8,104.6,223.5z M80.1,197.4c-0.5-0.2-0.7-0.8-0.5-1.3c0.6-1.6,1.2-3.2,2-4.7 c0.9-1.8,2-3.6,3.2-5.2c0.4-0.5,1-0.6,1.5-0.2c0.5,0.4,0.6,1,0.2,1.5c-1.1,1.5-2.2,3.1-3,4.9c-0.7,1.4-1.3,2.9-1.9,4.4 c-0.2,0.6-0.8,0.9-1.4,0.7C80.2,197.4,80.1,197.4,80.1,197.4z M135.5,223.7c-0.4-0.2-0.7-0.7-0.6-1.2c0.6-2.6,0.4-4.9-0.7-7.1 c-0.4-0.7-0.9-1.4-1.5-2c-0.4-0.4-0.4-1.1,0-1.5s1.1-0.4,1.5,0c0.7,0.8,1.4,1.6,1.8,2.5c1.3,2.6,1.6,5.5,0.9,8.6 c-0.1,0.6-0.7,0.9-1.3,0.8C135.7,223.8,135.6,223.7,135.5,223.7z M116.8,211.5c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.2-0.5,0-1.2,0.5-1.4c3.5-1.6,7.6-2,11.3-1.1c0.6,0.1,0.9,0.7,0.8,1.3c-0.1,0.6-0.7,0.9-1.3,0.8c-3.2-0.8-6.9-0.5-9.9,0.9 C117.5,211.6,117.1,211.6,116.8,211.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111,303.7c-0.4-0.2-0.7-0.8-0.5-1.3c0.2-0.6,0.8-0.9,1.3-0.7c1.7,0.5,3.4,0.8,5.1,0.9c0.6,0,1,0.5,1,1.1 s-0.5,1-1.1,1c-1.9-0.1-3.7-0.4-5.5-0.9C111.1,303.7,111,303.7,111,303.7z"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M250.7,139.6v32.1h47v44.4h-1.5v325.2c0,25.5,20.8,46.3,46.3,46.3l0,0c4,0,249.6,0.2,249.6,0.2V214 c0-41.1-33.3-74.4-74.4-74.4H250.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M218.6,204.6v-29.7c0-18.5,15.2-33.7,33.7-33.8c25.5,0,46.3,20.7,46.3,45.9v17.6H218.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M604,590.9c-50.8,0-248.1,0-248.1,0s50.1-10.3,33.4-72.1c76.9,0,264.1,0,264.1,0S670.2,590.9,604,590.9z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M622.6,380.5c0,0-1.2,1.6-6.8,3.1c-1.2,0.3-2.6,0.5-2.6,2.6c2.6,0,5.5,0,5.5,0l5.6-1v1h3.1 c0,0,0.8-5-0.9-5.6C624.9,380.5,622.6,380.5,622.6,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M622.3,376.9l0.3,3.6l0,0c1.1,0.8,2.6,0.8,3.7,0.1l0.2-0.1v-3.6H622.3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M650.9,381.2c0,0-1.2,1.6-6.8,3.1c-1.2,0.3-2.6,0.5-2.6,2.6c2.6,0,5.5,0,5.5,0l5.6-1v1h3.1 c0,0,0.8-5-0.9-5.6C653.2,381.2,650.9,381.2,650.9,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M650.6,377.6l0.3,3.6l0,0c1.1,0.8,2.6,0.8,3.7,0.1l0.2-0.1v-3.6H650.6z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M620,288.8l1.4,90h6.6c0,0,10-72.7,7.9-90C633.7,271.5,620,288.8,620,288.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M627,288.8c0,0,2.3,27.6,7.5,43c5.2,15.3,14.7,47.1,14.7,47.1h6.8c0,0-11.3-66.4-8.7-90l0,0H627V288.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M621.1,243c0,0-8.1,18.8-10.1,18.8c-1.6,0,0.6-15.4,0.6-15.4h-6.8c0,0-8.5,26.4-1.7,31.2 c6.8,4.8,21.6-13.6,21.6-13.6L621.1,243z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M645.2,291.2l-2.4,6.1c-1.2,2.4-5.5,2.4-8.4,1.7c-0.4-0.1-0.6-0.7-0.3-1c1.6-1.7,5.7-6.2,7.1-7.2L645.2,291.2 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M627.8,239.1c-2.6,0-5.2,1.3-6.5,3.6c-0.5,0.8-0.8,1.7-0.8,2.6c0,3.3,0,43.6,0,43.6h24.7v-40.7 c0,0-0.5-9.1-9.4-9.1C632.1,239,629.5,239,627.8,239.1z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "620.9,288.8 620.9,249.7 620,249.7 620,288.8  "
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M636.8,230.7l-2.6,9.9c0,0-2.3,1.8-5.2,1c-3-0.8-2.4-2.9-2.4-2.9l1.7-6.4h4.7L636.8,230.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M627.3,234.2c-0.9-0.3-1.7-0.6-2.1-1.2c-1.5-4.9,4.5-15.5,4.5-15.5l9.2,4.3l-1.7,7.7 c-0.5,2.1-1.9,3.8-3.8,4.6l0,0C631.4,234.7,629.3,234.8,627.3,234.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M634.4,220.8c0,0-3.3-0.3-6.5-1.7c-3.2-1.5-0.1-4.6-0.1-4.6s2.2,1.8,6.8,2.3c3.1,0.4,4,0,5.7,1.5 c2.2,2.1,0.4,6.6,0.4,6.6l-4.1,9.5l-0.5-0.1c0,0,1.4-5.9,2-7.9c-0.3-1.1-0.9-1.2-1.5-1.1c-0.6,0.1-1,0.6-1.2,1.2l-2.7,10.3 c0,0-7.3,1.1-8.8,0.1s1.6-8.3,1.6-8.3s2.1-0.3,3.2,1.7c1,2,3.3,0.8,3.3,0.8L634.4,220.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M606.1,246.5l0.2-1.3c0.5-2.9,3.3-6.5,6-7.4h2.9l-0.9,6.1l-4.1,2.6L606.1,246.5L606.1,246.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M637.4,225.1c-0.7-0.3-1.6,0.3-2,1.2s-0.1,1.8,0.6,2.1c0.7,0.3,1.6-0.3,2-1.2 C638.4,226.3,638.1,225.4,637.4,225.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M613.2,243.2l-5.6,3.2c0,0,3.5,0,3.6,0l5.9-5c0,0-0.4-0.9-1.8-0.1S613.2,243.2,613.2,243.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M642.6,241.8c0,0,14,15.5,14,24.8s-11.3,25.7-11.3,25.7l-5.6-1.6c0,0,5.1-20.3,5.1-25.7 c0-5.4-10.4-13.3-10.4-13.3"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M644.2,265c0,4.7-4.1,21.7-5.1,25.6c0.3,0.1,0.4,0.1,0.8,0.2c1.2-4.9,5.1-21.3,5.1-25.8 c0-5.5-10.1-13.3-10.6-13.6l-0.5,0.7C634.1,252.1,644.2,259.8,644.2,265z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M616.8,233.9c0,0,0.4,6.1-3.9,10.4c-0.3,0.3-0.7,0.4-1.1,0.4c-0.9,0-1.4-0.4-1.9-0.6c-0.7-0.3-0.9-0.7-1.1-1 c-0.1-0.3,0-0.6,0.2-0.8c0.9-1,3.7-4.6,3.1-8.1C614.3,233.1,616.8,233.9,616.8,233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M609.5,244c-0.4-0.3-0.5-0.4-0.6-0.7s0-0.6,0.2-0.8c0.9-1,3.7-4.6,3.1-8.1c0.8-0.5,1.6-0.7,2.3-0.7 C614.1,237.4,613,239.8,609.5,244z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M612.9,238.4c-0.3,0.8-0.8,1.4-1.1,1.3c-0.3-0.1-0.4-0.9-0.1-1.7c0.3-0.8,0.8-1.4,1.1-1.3 C613.2,236.9,613.2,237.6,612.9,238.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "612.9,236.8 612.6,236.6 612.6,236.8 612.8,236.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "611.9,239.8 611.5,239.6 612,239.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M612.6,238.4c-0.3,0.8-0.8,1.4-1.1,1.3c-0.3-0.1-0.4-0.9-0.1-1.7c0.3-0.8,0.8-1.4,1.1-1.3 C612.9,236.8,612.9,237.5,612.6,238.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M619,229.1l0.7,0.1c1.3,0.2,2.2,1.3,2,2.5l-0.2,1.7c-0.2,1.2-1.3,2-2.6,1.9l-0.7-0.1L619,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M598.6,228.3c-0.6,4.7,0,8.7,1.4,8.9c1.3,0.2,2.9-3.5,3.5-8.2s0-8.7-1.4-8.9 C600.8,219.9,599.2,223.6,598.6,228.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "604,225.8 601.9,226.8 601.6,229.5 603.3,231.6 604.4,228.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M603.5,228.9c0.5-4,0.1-7.4-0.8-8.5l0,0c7.3,6.8,16.6,8.8,16.6,8.8l-0.8,6c0,0-12.6-2.3-17.9,1.7l0,0 C601.8,236.1,603,232.9,603.5,228.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.5,228.1c-0.1,0.8-0.1,1.4,0.1,1.4c0.1,0,0.3-0.6,0.4-1.4c0.1-0.8,0.1-1.4-0.1-1.4 C601.8,226.7,601.6,227.3,601.5,228.1z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M609.2,242c0.2,0.1,0.9,0.5,3.1,0.5c1.6,0,2.4-2,2.6-3.1c0.1-0.4,0.2-0.9-0.3-1.2l-2.6-0.4L609.2,242z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453,372.4h56.4c0,0,1.1,35.2-5,36.3c-6.2,1.1-8.7-2.1-8.7-2.1s-6.4,10.5-17.1,11.8 c-10.7,1.4-25.6,1.6-25.6,1.6L453,372.4L453,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M480.4,418.1c4-0.6,21.5-4.2,25.4-10.3c-5.2,2.2-10.1-1.2-10.1-1.2S489.3,416.2,480.4,418.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "314.8,392.5 335.7,374.7 362.7,394.3 344.3,419 321.7,401  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.5,416.5c11.5-18.6,7.1-43.3-10.9-56.5c-17.9-13.2-42.8-10.3-57.2,6.2L379.5,416.5z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "178.5,420.6 152.3,412.5 135.3,441.3 161.9,456.6 175.6,431.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.7,468.3c-18-12.5-23.6-37-12.4-56.2c11.2-19.3,35.3-26.4,55-17L128.7,468.3z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M305.9,382.1l-18.8,2.5c0-0.1-2-13.2-13.2-20.7c-8.7-5.8-20.9-7.1-36.4-3.9c-17,3.5-29,9.9-34.6,18.5 c-5.6,8.4-3.6,16.6-3.5,17l-18.3,4.9c-0.4-1.6-4-15.9,5.6-30.9c8.5-13.3,24.4-22.5,47.2-27.2c21-4.3,38.3-2,51.4,6.9 C303,361.2,305.8,381.2,305.9,382.1z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -267.7477 329.2159)",
    className: "st2",
    cx: 263.5,
    cy: 487.8,
    rx: 120.4,
    ry: 120.4
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370,453.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.7-0.7-1.5-1.4-2.2-2.1c1.9,5.2,3.4,10.7,4.4,16.3 c11.4,59.2-27.6,116.6-86.8,128c-34.1,6.5-67.6-3.6-92.1-24.7c-0.1,0.6-0.3,1.2-0.5,1.8c24.8,21.1,58.5,31.2,92.9,24.6 c60.1-11.5,99.7-69.8,88.2-130C372.5,462.1,371.4,457.6,370,453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.2,424.4c15.8-22.2,39.8-38.6,68.5-44.2c3.8-0.7,7.5-1.2,11.3-1.6c-0.1-0.6-0.1-1.1-0.1-1.7 c-3.8,0.3-7.7,0.9-11.5,1.6c-28.8,5.5-52.9,21.8-68.9,43.9C174.8,423,175,423.7,175.2,424.4z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -267.3315 329.7491)",
    className: "st20",
    cx: 264.4,
    cy: 487.6,
    rx: 100,
    ry: 100
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 246.8,
    y: 391.7,
    transform: "matrix(0.9821 -0.1884 0.1884 0.9821 -71.4287 53.9449)",
    className: "st2",
    width: 2.5,
    height: 22
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 561.2,
    transform: "matrix(0.9821 -0.1883 0.1883 0.9821 -102.7256 63.0647)",
    className: "st2",
    width: 2.5,
    height: 22
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.1,
    y: 469.9,
    transform: "matrix(0.9821 -0.1884 0.1884 0.9821 -82.5174 74.2049)",
    className: "st2",
    width: 22,
    height: 2.5
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.6,
    y: 502.4,
    transform: "matrix(0.9821 -0.1884 0.1884 0.9821 -91.6659 42.8574)",
    className: "st2",
    width: 22,
    height: 2.5
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.1,
    y: 530.1,
    transform: "matrix(0.5614 -0.8276 0.8276 0.5614 -296.4279 515.3829)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.9,
    y: 429.6,
    transform: "matrix(0.5612 -0.8277 0.8277 0.5612 -278.3116 348.743)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 412.2,
    transform: "matrix(0.5612 -0.8277 0.8277 0.5612 -204.0416 441.2005)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.4,
    y: 560.3,
    transform: "matrix(0.5613 -0.8276 0.8276 0.5613 -370.6911 422.9419)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 329.5,
    y: 434.3,
    transform: "matrix(0.8144 -0.5803 0.5803 0.8144 -190.0283 276.1713)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.7,
    y: 538.2,
    transform: "matrix(0.8143 -0.5804 0.5804 0.8143 -277.4013 210.9149)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 275.2,
    y: 398.7,
    transform: "matrix(0.2074 -0.9783 0.9783 0.2074 -166.9554 592.9459)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 573.8,
    transform: "matrix(0.2074 -0.9783 0.9783 0.2074 -367.7765 695.473)",
    className: "st2",
    width: 14.5,
    height: 1.7
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 405.8,
    transform: "matrix(0.828 -0.5607 0.5607 0.828 -194.8378 190.8481)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.2,
    y: 554,
    transform: "matrix(0.8281 -0.5606 0.5606 0.8281 -260.6345 272.5458)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.4,
    y: 461.3,
    transform: "matrix(0.207 -0.9783 0.9783 0.207 -318.6938 543.9966)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 498.4,
    transform: "matrix(0.2071 -0.9783 0.9783 0.2071 -216.019 744.7141)",
    className: "st2",
    width: 1.7,
    height: 14.5
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.8,490.9c-10.9-25.6-13.5-48.8-14.2-60.7c-0.1-2.3,2.9-3.1,4-1.1c3.9,7.3,8.4,18.5,10.8,25.6 C273.3,472.2,269.6,493.7,266.8,490.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.4,492.1c-16.4,22.4-34.9,36.6-44.9,43.3c-1.9,1.3-4.2-0.9-3-2.9c4.2-7,11.6-16.7,16.5-22.4 C250,496.1,270.3,488.3,269.4,492.1z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.5,487.4c0.9,4.7,5.5,7.8,10.2,6.9s7.8-5.5,6.9-10.2s-5.5-7.8-10.2-6.9 C258.7,478.1,255.6,482.6,256.5,487.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.3,486.4c0.4,2.1,2.4,3.4,4.4,3c2.1-0.4,3.4-2.4,3-4.4c-0.4-2.1-2.4-3.4-4.4-3S260.9,484.4,261.3,486.4z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M389.9,365.1c-0.1-0.6,0.3-1.2,0.9-1.3l14.7-2.9c0.6-0.1,1.2,0.3,1.3,0.9s-0.3,1.2-0.9,1.3l-14.7,2.9 C390.6,366.1,390,365.7,389.9,365.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M351,339.2c0.6-0.1,1-0.7,0.9-1.3l-2.9-14.7c-0.1-0.6-0.7-1-1.3-0.9c-0.6,0.1-1,0.7-0.9,1.3l2.9,14.7 C349.8,338.9,350.4,339.3,351,339.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.8,347.1c-0.5-0.3-0.6-1-0.3-1.5l8.3-12.5c0.3-0.5,1-0.6,1.5-0.3c0.5,0.3,0.6,1,0.3,1.5l-8.3,12.5 C371,347.3,370.3,347.4,369.8,347.1z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M99.3,425.1c-0.1-0.6-0.7-1-1.3-0.9l-14.6,3.1c-0.6,0.1-1,0.7-0.9,1.3c0.1,0.6,0.7,1,1.3,0.9l14.6-3.1 C99.1,426.2,99.4,425.7,99.3,425.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.8,385.9c-0.6,0.1-1.2-0.3-1.3-0.9l-3.1-14.6c-0.1-0.6,0.3-1.2,0.9-1.3c0.6-0.1,1.2,0.3,1.3,0.9 l3.1,14.6C125.8,385.2,125.4,385.8,124.8,385.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M110.6,400.5c0.3-0.5,0.2-1.2-0.3-1.5l-12.5-8.2c-0.5-0.3-1.2-0.2-1.5,0.3s-0.2,1.2,0.3,1.5l12.5,8.2 C109.6,401.2,110.3,401.1,110.6,400.5z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296.2,446c-1,6.4,3.4,12.4,9.8,13.4s12.4-3.4,13.4-9.8s-3.4-12.4-9.8-13.4 C303.2,435.1,297.2,439.5,296.2,446z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.6,434.7c-0.5,3.2,1.7,6.2,4.9,6.7c3.2,0.5,6.2-1.7,6.7-4.9c0.5-3.2-1.7-6.2-4.9-6.7 C290.1,429.3,287.1,431.5,286.6,434.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "123.8,462.8 141.6,488.2 135.5,490.2 118.5,477.9 119.3,469.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M120,450.7c8,5.8,1.8,55.4,1.8,55.4l-32.2-6.3C89.6,499.9,92.1,449.6,120,450.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M115.8,450.9l3.1-4.6l5.6,2.9l-1.9,6.2c-0.1,0-0.1,0.1-0.2,0.1C120.6,453.5,118.3,451.9,115.8,450.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119.6,435.2l-1.5,8.5c0.8,0.2,1.1,1.2,0.8,1.9c0,0.2,0,0.4,0,0.7c1.2,1.4,3.5,3.4,7.1,3.5 c5.6,0.2,4.8-10.9,4.8-10.9L119.6,435.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.4,440.9c0.1-0.6-0.4-2.1-0.8-2.7c-2.4-3.3,0.7-4.6,1.8-5c1.2-0.4,1.5-2.4,3.1-3.2 c2.5-1.2,4.1,1,5.5,1.1s2.7-1.5,4.4-0.1s1.2,2.9,1.6,3.7c0.5,0.8,2-0.7,3.5,1.8c2.2,3.8-3.8,3.8-3.8,3.8s-3.4,0.6-7.2-2 c-0.5-0.4-1.2-0.4-1.7,0c-1.3,1.1-3,8.2-3,8.2l-1.1-1.5C117.8,445,114.9,443.8,115.4,440.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M118.4,442.4c0.1,0.7,0.8,1.2,1.5,1.1s1.2-0.8,1.1-1.5c-0.1-0.7-0.8-1.2-1.5-1.1 C118.8,440.9,118.3,441.6,118.4,442.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M61,558c0,0-2.6,2.8-4.2,9.1c-0.4,1.4,0.1,2.9-2.2,2.9c0-2.9,0-7.6,0-7.6l1.1-6.4h-1.1v-3.4 c0,0,5.6-1,6.3,1C61,555.4,61,558,61,558z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M65,557.3l-4,0.7l0,0c-0.9-1.3-0.9-2.9-0.1-4.2l0.1-0.2l4-1V557.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M113.5,587.8c0,0,0,4.3,8.6,6.9c1.8,0.5,1.2,1,1.5,1.8c-2.8,0-9.9,0-9.9,0l-3.9-4.4l-1.2,1l-2.8-2.7 c0,0,1.3-4,3.4-4C111,587,113.5,587.8,113.5,587.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.1,584.1l-1.6,3.7l0,0c-1.5,0.4-3-0.1-4-1.2l-0.2-0.2l1.3-3.8L115.1,584.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.3,511c0,0,0.4,12.7,5.2,23.8c1.5,3.4-0.5,7.3-4.1,8.1c-17.6,3.7-27.5,9.6-27.5,9.6v6l40.9-5.6 c6.6-0.9,11.7-6.2,12.4-12.8l1.3-12.7L90.3,511z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.8,509.2c0,0,14.2,26.5,14.2,34.8s-19,40.3-19,40.3h-5.4c0,0,1-20.3,4.7-37.2 c0.7-3.3-0.3-6.8-2.8-9.1c-11.6-10.9-21.8-28.8-21.8-28.8H119.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.8,478.4c1,3-0.6,2.6-3.6,7.3L44.5,538.5c-3,1-6.3-0.6-7.3-3.6l-3.4-9.8c-1-3,0.6-6.3,3.6-7.3 L192.1,465c3-1,3,3.7,4,6.7L202.8,478.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M35.7,530.6l1.5,4.4c1,3,4.3,4.6,7.3,3.6l154.7-52.8c3-1,2.1-11.7,2.1-11.7L35.7,530.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.1,527.5l-3.4-9.8c-1-3-4.3-4.6-7.3-3.6l-10.9,3.7c-3,1-4.6,4.3-3.6,7.3l1.9,5.5l0,0l1.5,4.4 c1,3,4.3,4.6,7.3,3.6l10.9-3.7C58.5,533.8,60.1,530.5,59.1,527.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 829.03,
    y1: -581.2066,
    x2: 850.9751,
    y2: -581.2066,
    gradientTransform: "matrix(0.3233 0.9463 0.9463 -0.3233 335.8229 -460.1988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0F0EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0E4EF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "57.1,534.3 64.8,531.7 57.7,510.9 50,513.5  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "210.4,468.6 215.4,469 211.5,472.4 209.5,471.2  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.5,472.4c-0.4-0.4-0.7-1-0.9-1.6c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.2-0.7-0.2-1c0,0,0,0,0-0.1s0-0.3,0-0.4 c0-0.2,0-0.3,0-0.5l-17.5-3.9l3.7,10.8l3.4,10L211.5,472.4z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.3,467.4l11.2,6.9l-8.1,9.3l-1.2,26.3l-4.4-0.8c0,0-6.8-20.3-5.5-27.3C90.8,474.7,97.3,467.4,97.3,467.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.3,509.9v5.2c0,0.8-0.3,1.7-0.7,2.4c-0.9,1.3-2.4,3.3-3.9,3c-2.2-0.4-4.7-5.4-4.7-5.4l5-6L99.3,509.9z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M349.4,204.4l0.7,4.4l0,0c-1.4,0.9-3.1,1-4.6,0.2l-0.3-0.2l-1.1-4.4H349.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.3,103.1c3.9,12.8,16.9,32.6,16.9,32.6l-10.3-4.2l-7.3-16.8C313.7,114.6,310.4,90.3,314.3,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M342.4,154.7l8.1,50.2h-7.2c0,0-16.2-45.1-17.9-58.4c0-7.5,16.4,0,16.4,0L342.4,154.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315.4,82.8 312.7,89.8 306.9,85.6 310.8,77.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M317.6,84c0.9,0.2,1.8,0.2,2.3-0.1c3.4-3.2,2.6-14,2.6-14l-3.8-2.6l-6,2.2l-1.7,6.8 c-0.5,1.8,0,3.7,1.4,5.2l0,0C313.8,82.7,315.7,83.6,317.6,84z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M313.8,71.8c0.5-1.1,1.8-1.6,2.9-1.2c0.8,0.3,1.8,0.7,2.8,0.9c2.3,0.5,6.7,0.4,7.4-3.1 c0.7-3.6-3.9-3.3-3.9-3.3l-6.2,0.4c-1.8,0.1-3.6-0.2-5.3-1c-1.5-0.6-2.8,0.7-3.1,1.6c-0.7,2,0,5.4,0.6,7.6 c0.4,1.3,0.9,2.5,1.7,3.5l0,0L313.8,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M310.3,73.3c0.6-0.4,1.6-0.1,2.1,0.7c0.6,0.7,0.5,1.6-0.1,1.9c-0.6,0.4-1.6,0.1-2.1-0.7 C309.7,74.5,309.7,73.6,310.3,73.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M350.3,208.4c0,0,0,4.7,9.4,7.5c1.9,0.6,1.3,1.1,1.7,1.9c-3.1,0-10.8,0-10.8,0l-4.2-4.7l-1.3,1.1l-3-3 c0,0,0.5-4.3,2.8-4.4C346.8,207.5,350.3,208.4,350.3,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M323.7,203.1l-1.7,4l0,0c-1.6,0.5-3.3-0.1-4.4-1.3l-0.2-0.2l1.4-4.1L323.7,203.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314,87.9c0,0,0.7-1.1-5.9-4.6c-10,10-13.2,48.1-13.2,48.1s23.3,0,26.1,0C321.9,109.7,314,87.9,314,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M339.8,130.4c0.1-0.5-0.1-1-0.5-1.3l-4.2-2.5c-1.1-0.6-2.3-0.8-3.5-0.6l-4.6,0.2l-0.6,0.7l-1,4.1 c0.9-0.2,1.5-0.4,1.5-0.4l2.9,0.1c0,0,5.5,5.1,8.3,0.7c0.1,4.7,1.5,4.4,1.5,4.4L339.8,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.9,131.5l-0.4,3.2v0.1c-0.7,6.2,3.4,11.9,9.4,13.6c0,0,11.9,3.9,26.8,4.8c-9.8,12.6-12.6,48.1-12.6,48.1 l6.3,2.3l24.5-58.3c1.6-3.7-0.6-8-4.6-8.8l-23.4-5L294.9,131.5L294.9,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,100.3c0,0-4.9,4.4-7.7,9c-0.8,1.3-0.7,2.9,0.3,4c5.4,6.3,24.8,12.3,24.8,12.3l-1.3,7.1 c0,0-27.5-5.4-37.2-15.2c-10-10,15.8-30.9,15.8-30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.8,109.6c-0.7,1.1-0.6,2.6,0.3,3.6c2.5,2.9,9.1,5.9,14.9,8.1c0,0.4,0,0.4,0,0.8 c-6.1-2.3-12.7-5.3-15.4-8.4c-1.1-1.3-1.2-3.1-0.3-4.5c2.9-4.6,7.7-9,7.8-9.1l0.5,0.6C311.4,100.7,306.6,105.1,303.8,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.9,121.5c10.5,5.7,26,9.8,31.5,10.9c-0.1,0.3-0.1,0.6-0.2,0.7c-5.3-1.1-20.6-5-31.5-10.8 C295.8,122.1,295.8,121.7,295.9,121.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "350,138.9 358.2,109.9 356.7,109.5 348.9,137.2 325.6,133.1 325.3,134.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M322.4,206.2c0,0-0.4,4.7,9,7.5c1.9,0.6,1.3,1.1,1.7,1.9c-3.1,0-10.8,0-10.8,0l-4.2-4.7l-1.3,1.1l-3-3 c0,0,1.4-4.3,3.7-4.4C319.3,205.4,322.4,206.2,322.4,206.2z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 326.9,
    y: 228.2,
    className: "st6",
    width: 39,
    height: 37.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 395.1,
    y: 228.2,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 463.5,
    y: 228.2,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 228.2,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 326.9,
    y: 300.8,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 395.1,
    y: 300.8,
    className: "st6",
    width: 39,
    height: 37.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 463.5,
    y: 300.8,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 300.8,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 395.1,
    y: 372.7,
    className: "st22",
    width: 39,
    height: 37.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 372.7,
    className: "st22",
    width: 39,
    height: 37.8
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M572.7,378.6c-3.2,5.5-6.4,11-9.6,16.5c-1.5,2.5-2.9,5-4.4,7.5c-0.4,0.7-0.9,1.5-1.3,2.2 c-2.5-2.5-4.9-5.4-7.1-7.5c-4.7-4.5-9.4-9.1-14.2-13.6c-8.2-7.8-20.6,4.6-12.4,12.4c6.3,6,12.6,12.1,18.9,18.1 c4.7,4.5,9.7,11.3,16.9,10.8c7.1-0.6,10.3-6.5,13.6-12.1c4.9-8.5,9.9-17,14.8-25.4C593.6,377.7,578.4,368.8,572.7,378.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M502.7,568.5l3.3,8.7c0.3,1.2,0.3,2.7-0.9,3.4c0,0-0.8,0.5-1.7,0.8c-0.6-0.1-4.4-11.9-4.4-11.9v-0.1 C500.5,567.5,502.7,568.5,502.7,568.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "503.4,581.4 499,569.6 498.4,569.9 502.8,581.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.1,572 504.3,572.8 502.8,573.1 502.5,572.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.7,573.7 505,574.5 503.5,574.7 503.2,574  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M506.4,566.5l-3.7,2.1l0,0c-0.2,0.9,0.1,1.8,0.8,2.4l0.1,0.1l4-1L506.4,566.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M535.6,511.5c0,0-3.6,3.9-4.6,10.8c-0.6,4.6,1.1,11.8,1.3,17.5c0.2,5.2-2.2,9.3-6.3,12.5l-19.6,14.2 l1.3,3.5c0,0,26.8-4,33.8-16s8.7-39.2,8.7-39.2L535.6,511.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M520,496.7l-10.1,22.5c0,0-4.1,0.5-5.9,2.1c-0.9,0.8-0.9,2.5-0.6,3.9c0.2,1.1,1.5,1.5,2.3,0.8 c1.1-1,2.5-2,3.5-2.2c2.5-0.4,3.2-2.2,3.2-2.2l14.5-22.7L520,496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M570.8,451.5l5.2-4.4l-4-21.8l-6.2-3.2c0,0,0.7-1.2,2.2-0.7s2.8,0.2,2.8,0.2s1.2-1.4-1-2.4 c-1.2-0.8-2.1,0-5.7-0.1c0-0.6,4.7-1.9,4.7-1.9c1.5-0.5,5.2,2.4,5.2,2.4c0.3,0.3,0.4,0.7,0.5,1.2l0.6,4c0,0,8,21.9,8,24.3 c0,2.3-4.5,5.6-4.5,5.6L570.8,451.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M543,513.8c0,0-3.1,3.7-1.2,12.4c1.2,5.5,6.4,12.5,9.9,17.3c2.5,3.4,2.6,7.8,1.8,12 c-2.9,16,1.7,35.5,1.7,35.5h3.7c0,0,5.6-28.6,7.2-48.6c1.5-18.1-6.3-31.4-6.4-31.7L543,513.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 568.2,
    y: 414.7,
    transform: "matrix(0.1452 -0.9894 0.9894 0.1452 70.8684 923.2713)",
    className: "st23",
    width: 3.1,
    height: 11.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.2,
    y: 420.9,
    transform: "matrix(0.1452 -0.9894 0.9894 0.1452 75.108 929.887)",
    className: "st4",
    width: 3.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M575.8,423.1c0.9,0.1,1.6,0.1,1.8-1.3c0.2-1.5-0.5-1.7-1.3-1.8L575.8,423.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.7,421.3 561.4,419.9 561.6,418.8 564.1,418.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "561.4,419.9 560.4,419.2 561.6,418.8  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 569.1,
    y: 415.6,
    transform: "matrix(0.145 -0.9894 0.9894 0.145 70.0062 923.64)",
    className: "st24",
    width: 0.7,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.3,
    y: 414.1,
    transform: "matrix(0.1453 -0.9894 0.9894 0.1453 71.5375 922.452)",
    className: "st24",
    width: 0.7,
    height: 11.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M533.9,469.6c-6.7,4.9-14.5,28.4-14.5,28.4l5.8,3.3l9.5-13.1c0,0,0.9,15.1-1.3,26.7c1,4.3,6,3.9,14,2.3 c8-1.5,13.2-5,13.2-5s0.3-21,1.4-32.1c1-11.1-1-12.3,1.8-11.9c6.3-3.6,16.5-15,16.5-15l-9.5-1.9l-20.5,12 C550.3,463.5,540.2,466.1,533.9,469.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M545.5,441.8l4.9,4.9c2.1,2.1,3,5.1,2.3,8l-0.6,2.6L545.5,441.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M539.5,440c-12,0-6.9,23-6.9,23s2.1,15,6.9,21c4.1,5.2,12.3,3.6,16.1,1.1c1.9-1.2,4-2,6.2-2.3 c3.3-0.4,7.2-1.8,7.2-7.7c0-5.6-6.6-9.9-11-12.9c-2.8-2-4.8-5-5.7-8.4C551,448.1,547.6,440,539.5,440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M555.9,595.1h9.3c1.2,0.2,2.6,0.6,2.9,2.1c0,0,0.2,0.9,0.1,1.9c-0.3,0.5-12.7-0.1-12.7-0.1l-0.1-0.1 C554.1,596.9,555.9,595.1,555.9,595.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "568.2,599.1 555.5,599 555.6,599.7 568.2,599.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "559.5,595.1 560.4,595.1 560.1,596.7 559.3,596.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "561.3,595.1 562.2,595.1 561.9,596.7 561.1,596.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M555.2,591l0.6,4.1l0,0c0.7,0.5,1.7,0.5,2.5,0.1l0.1-0.1l0.4-4.1H555.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M567.9,421.4c-1.5-0.5-2.2,0.7-2.2,0.7l4.1,2.1c0.1,0,0.1-0.1,0.2-0.1c0.7-0.3,2.1-0.9,2.7-1 C572.4,422.7,568.7,421.6,567.9,421.4z"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M526.1,297.8c-14.2,8.4-16.2,27-6.7,39.8c9.5,12.9,28,18,42.6,11c13.4-6.4,21-22.9,15.2-37 c-6.6-15.9-25.4-21.5-40.1-13.1c-3.4,2-0.3,7.2,3.1,5.2c11.7-6.7,26.6-2.3,31.6,10.6c4.3,11.2-2.2,24.1-12.8,29 c-11.4,5.2-25.7,1.4-33.7-8.1c-8.3-9.8-7.8-25.3,3.9-32.2C532.6,301.1,529.5,295.8,526.1,297.8L526.1,297.8z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M513.7,247.4c5.3-15.6-5.2-31-20.7-34.6c-15.6-3.6-33,4.5-39.6,19.3c-6.1,13.6-1.1,31.1,12.5,38 c15.4,7.8,33.3-0.2,39-16.1c1.3-3.7-4.4-5.7-5.7-2c-4.5,12.7-18.7,19.1-30.9,12.5c-10.6-5.7-14-19.8-9.1-30.4 c5.3-11.4,18.7-17.7,30.8-15.7c12.7,2.1,22.4,14.2,18,27C506.7,249.1,512.4,251.1,513.7,247.4L513.7,247.4z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M322.5,228.8h49.4c0,0,1,30.8-4.4,31.8s-7.6-1.9-7.6-1.9s-5.6,9.2-15,10.4s-22.4,1.4-22.4,1.4V228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M346.5,268.9c3.5-0.5,18.9-3.7,22.3-9.1c-4.5,1.9-8.9-1-8.9-1S354.3,267.2,346.5,268.9z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "363.2,422.5 352.6,450.2 346,445.2 360.9,420.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M361.9,414.2c-0.7,0.8-1,1.9-1,2.9l-0.5,4l0.5,0.6l1.9,1.7c-0.1-0.8-0.2,0-0.2,0l3-5.2c0,0,3.6-2.3-1-5.8 c-0.4-0.3-1.1-0.4-1.5-0.1C362.1,413,361.9,414.2,361.9,414.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M339.9,470.2c7.6-10.2,12.8-20,12.8-20l-5.7-6.5l-7,8.2L339.9,470.2L339.9,470.2z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M323.3,590l3.4,0.6c0.7-4.2,11.2-24,12-34.3c0.9-11.4,3.6-24.1,3.6-24.1l-11.3-3.4c0,0-2.9,0,0.3,23.3 C324.3,561.4,322.4,582.3,323.3,590z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M331.6,520.3c0,0,2.6,15.9,6.3,33c-3.8,10.3,2,39,2.1,38.9c0.4-0.4,2.5,2.1,2.5,2.1s4.3-25.3,5.2-36.8 s1.2-25.4,1.2-25.4L331.6,520.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M339.6,590.6c0,0-1.6,1.4-1.3,3.1c0.3,1.7,0.7,5.8,0.7,5.8h1.6l-0.1-3.8c0-0.2,3.5,3.8,4.1,3.8h8.7 c0,0,0.6-2.6-4.5-3.4C343.8,595.3,339.6,590.6,339.6,590.6z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M327.1,587.7l-0.2,3.6c0,0.8,0.2,1.5,0.6,2.1c0.5,0.7,1.3,1.6,2.6,2.7c-2.5,0.8-4.8-2-6-3.9 c-0.6-0.9-0.8-2-0.7-3.1l0.4-2.8L327.1,587.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M323.3,589.7c0,0-2.2,0.2-2.6,1.9s-1.4,5.1-1.4,5.1l1.2,1l1.7-3.4c0,0,3.7,5,4.3,5.2h9.5c0,0,0-3.2-6-3.3 C324.6,596.1,323.3,589.7,323.3,589.7z"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "342.3,455.6 335.5,455.6 338.2,447.6 343.6,450.9  "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 355.1,
    y: 372.8,
    transform: "matrix(0.3629 -0.9318 0.9318 0.3629 -108.5153 596.735)",
    className: "st23",
    width: 54.1,
    height: 9.8
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M369.5,401.8l-0.3-0.1c0,0,16.7-47.5,19.6-50.4s8.8-4.6,3.2,1.2C386.3,358.4,369.5,401.8,369.5,401.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M392.3,238.7c11.6,0,23.2-0.3,34.6,1.1c1.8,0.2,9.7,0.5,4.5,0.4c1.3,0.4,2.6,0.9,3.9,1.3 c4.2,3.1,7.8,6.8,12.3,9.6c4.3,2.6,8.6,4.4,13.1,5.7c14.8,17,19.9,41.5,11.1,64c-10.6,27.3-38.3,43-66.2,39.6 c-2.1-1.3-4.3-2.4-6.7-3.3c-0.8-0.4-1.6-0.8-2.4-1.1c-3.2-1.9-6.4-3.7-9.8-5.1c-3.5-1.5-7.2-2.3-10.9-2.5 c-22.2-16.5-31.6-46.2-21.1-73.2C361.5,257.4,375.6,244.6,392.3,238.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.3,
    y1: 340.75,
    x2: 472.0606,
    y2: 340.75,
    gradientTransform: "matrix(1 0 0 -1 0 640)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0F0EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0E4EF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M414.2,359c-4-2.3-8.4-3.7-13.2-4c-3.1-0.1-6.1-0.3-9.2-0.8c-0.2,0-0.3-0.1-0.5-0.1l44.6-114.6 c29.7,13.9,43.9,48.7,31.9,79.7C458.8,342.4,437.4,357.2,414.2,359z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M354.6,275.2c-12.6,32.4,3.4,68.8,35.8,81.4c32.3,12.6,68.8-3.4,81.4-35.8c12.6-32.3-3.4-68.8-35.8-81.4 C403.6,226.8,367.2,242.8,354.6,275.2z M361.2,277.7c11.2-28.7,43.5-42.9,72.2-31.8c28.7,11.2,42.9,43.5,31.8,72.2 C454,346.8,421.7,361,393,349.9S350,306.4,361.2,277.7z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M349.1,452.1l21.5-64.2c0.6-1.6,2.4-2.4,3.9-1.9l7.7,3c1.5,0.6,2.2,2.4,1.6,4l-17.3,44.3 C363.9,433.3,354.5,453.3,349.1,452.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M341.8,458.4l28.8-70.6c0.6-1.5,2.1-2.3,3.5-1.9c-0.2,1.4-18.4,54.8-25.9,78.1 C346.5,463.1,343.8,458.9,341.8,458.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M402.4,272c-1.6,4.2-6.3,6.2-10.5,4.6s-6.2-6.3-4.6-10.5s6.3-6.2,10.5-4.6C401.9,263.2,404,267.9,402.4,272z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M386.5,281.6c-0.8,2-3,3-5,2.2s-3-3-2.2-5s3-3,5-2.2C386.3,277.3,387.3,279.6,386.5,281.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351.4,464.3c0-0.2-0.1-0.4-0.1-0.6c6.8-8.7,12.5-14.8,12.5-14.8l-5.7-6.5l-13,12.4h-3.8c0,0-5.2-3.4-9.7,1.2 c-1.6,1.7-2.7,6.3-1.6,11.2c3,13.4,0.7,20.6,0.7,20.6l17.6,6.6c0,0,0.4-11.7,0.7-19.9l0,0c0.1-1.6,0.6-3.1,1.4-4.5 C351.1,468.3,351.7,466.4,351.4,464.3z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "374.3,421.2 363.8,448.9 357.1,443.9 372,418.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373,412.8c-0.7,0.8-1,1.9-1,2.9l-0.5,4l0.5,0.6l1.9,1.7c-0.1-0.8-0.2,0-0.2,0l3-5.2c0,0,3.6-2.3-1-5.8 c-0.4-0.3-1.1-0.4-1.5-0.1C373.3,411.7,373,412.8,373,412.8z"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M348.4,487.3c0,0,2.3,11.9,2.3,19c0,3.9-1,28.4-1,28.4s-16.7,1.2-20,1.2c-0.8-20.1-5.4-20.7-5.4-30.1 c0-4.1,2.1-8.7,3.7-11.6c1.2-2.1,1.9-3.6,2.3-6.5l0.1-0.4L348.4,487.3z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M344.7,433.2l-11.2,3.9l1.1,8.3c0,0.1,0,0.2,0.1,0.3c0.2,0,0.4,0.1,0.6,0.1h0.1h0.1c2.6,0.6,4.4,2.8,5.2,5.2 c1.6,0.3,3.2,0.3,4.8-0.1c1.1-0.2,2.1-0.6,2.5-1.1C350.5,444.9,344.7,433.2,344.7,433.2z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M344.5,440.3c-3,1.5-2.3,17-2.8,27.6c-0.3,5.7-4.5,10.3-10.2,11.2c-4,0.6-8.4,0.8-11-0.8 c1.7-1.4,11.2-15.3,8.1-33.6c-0.4-2.4-0.4-9.1,3.6-12.8c4.5-4,13.8,1.2,13.8,1.2S348.6,438.3,344.5,440.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration02);
export default __webpack_public_path__ + "static/media/illustration_02.482d79ca88dcd7646d356b674a44e56e.svg";
export { ForwardRef as ReactComponent };